module.exports = __webpack_public_path__ + "img/tarj2-7.4ee8b319.png";